document
  .querySelector("button[name='add_bundle_custom']")
  .addEventListener("click", function (e) {
    // Get the active bundle item
    this.classList.add("btn--loading");
    this.setAttribute("disabled", "disabled");
    var btnForm = this;
    const activeItem = document.querySelector('.custom_bundle_item.active');
    if (activeItem) {
      var cpSizeActive = activeItem.querySelectorAll('.cp_size_select.active');
      // Final array to store items
      let itemsArray = [];

      // Subscription: checkbox ticked → send Recharge selling plan
      const subChecked = document.querySelector('.custom-rechage-app .pt-checkbox__input')?.checked;
      const sellingPlanId = document.querySelector('select[name="selling_plan"]')?.value;

      cpSizeActive.forEach((bunelitem)=>{
        // Get variant id from selected option
        let variantId = bunelitem.value;  // replace later with correct variant ID

        const item = { id: variantId, quantity: 1 };
        if (subChecked && sellingPlanId) {
          item.selling_plan = sellingPlanId;
        }

        // Push into array
        itemsArray.push(item);

        // Push into array
        /* itemsArray.push({
          id: variantId,
          quantity: 1
        }); */
      });

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          var tempShippingProtect = 0;
          if (cart.items.length > 0) {
            cart.items.forEach(function(itemtemp) {
              //console.log("item.id-pdp->", itemtemp.id)
              if(itemtemp.properties['_type'] === 'shipping_product') {
                tempShippingProtect = 1; // Shipping product exists
              }
            });
            
            //console.log("tempShippingProtect--PDP->", tempShippingProtect);
            if (tempShippingProtect == 0) {
              var properties = {};
              properties['_type'] = 'shipping_product';
              itemsArray.push({
                id: '50799000322322',
                quantity: 1,
                properties:properties
              });
            }
          }
          else{
            //console.log("elset--->")
            var properties = {};
            properties['_type'] = 'shipping_product';
            itemsArray.push({
              id: '50799000322322',
              quantity: 1,
              properties:properties
            });
            //console.log("item---->", items)
          }
        }
      });
      
      setTimeout(function(){
        console.log({itemsArray})
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: itemsArray }),
        })
        .then((response) => {
          if (!response.ok) {
            alert('Cart Error : Variant can only be purchased with a selling plan.');
            return false;
          }
          theme.ajaxCart.update();
          console.log("btnForm---<", btnForm)
          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
          
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);

          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
        });
      },1000);
    }
    else{
      btnForm.classList.remove("btn--loading");
      btnForm.removeAttribute("disabled");
    }
});
